import ActionButton from "#/components/buttons/ActionButton";
import type { Ticket } from "#/types/tickets";
import { sanitize } from "#/utils/StringUtils";
import { Card } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

export interface Props {
  ticket: Ticket;
}

export const TicketPreviewCard = ({ ticket }: Props) => {
  const { t } = useTranslation();
  return (
    <Card
      withBorder
      shadow="sm"
      radius="md"
      p="0"
      py={8}
      mb="sm"
      classNames={{
        root: "border border-green-500 transition-all duration-300 bg-green-50",
      }}
    >
      <div className="w-full flex flex-col px-3">
        <div className="w-full flex items-center justify-between">
          <span className="text-2xs text-gray-400 font-bold">
            {ticket.id ?? "--"}
          </span>
        </div>
        <span className="text-lf font-bold capitalize">
          {sanitize(ticket.task) ?? "--"}
        </span>
        <span className="text-2xs font-medium uppercase text-gray-500">
          Items : 111
        </span>
      </div>
      <div className="px-3 w-full flex items-center h-fit justify-between border-t border-t-gray-200 pt-2">
        <span className="text-2xs font-bold uppercase text-gray-500">
          {t("common.showDetails")}
        </span>
        <ActionButton
          color="gray"
          variant={"outline"}
          icon={IconChevronDown}
          size={"xs"}
        />
      </div>
    </Card>
  );
};
